export type CalendarEvent = {
  startDate: string;
  endDate: string;
  name: string;
  description?: string;
  addressLines?: Array<string>;
};

// 'https://calendar.google.com/calendar/u/0/r/eventedit?dates=20240128/20240129&text=Child+Dedications+-+Concord&details=Child+dedications+are+a+time+for+parents,+to+commit+themselves+to+raising+their+child+God%E2%80%99s+way.+It%E2%80%99s+a+powerful+time+for+parents+to+embrace+the+responsibility+they%E2%80%99ve+been+given+by+God+and+to+see+the+impact+they+can+make+in+their+child%E2%80%99s+life.++We+make+these+events+special+by+encouraging+the+whole+family+to+get+involved+since+it+is+an+event+that+families+will+always+remember.+We+invite+families+with+children+ages+0+%E2%80%93+4+years+to+participate+in+the+dedication.++Space+is+limited.&uid=4baca8e3-d083-440f-8097-7df607d1398f';
export function createGoogleCalendarLink(event: CalendarEvent): string {
  const start = getISODate(new Date(event.startDate));
  const end = getISODate(new Date(event.endDate));
  const dates = `${start}/${end}`;
  const text = (event.name || '').replace(/ /g, '+');
  const details = (event.description || '').replace(/ /g, '+');
  const location = event.addressLines?.join(' \n') ?? '';
  const baseUrl = 'https://calendar.google.com/calendar/u/0/r/eventedit';
  const params = {dates, text, details, location};
  return `${baseUrl}?${objectToQueryParams(params)}`;
}

export function createICSDataLink(event: CalendarEvent): string {
  const {
    startDate,
    endDate,
    name,
    description,
    addressLines,
  } = event;

  const start = new Date(startDate);
  const end = new Date(endDate);
  const now = new Date();
  const location = addressLines?.join('\n');

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Regolith GmbH.//regolith.co//EN',
    'METHOD:REQUEST',
    'BEGIN:VEVENT',
    `UID:event-${now.getTime()}@event.chapel.at`,
    `LAST-MODIFIED:${getISODate(now)}`,
    `DTSTAMP:${getISODate(now)}`,
    `DTSTART:${getISODate(start)}`,
    `DTEND:${getISODate(end)}`,
    name && `SUMMARY:${name}`,
    description && `DESCRIPTION:${description}`,
    location && `LOCATION:${location}`,
    'SEQUENCE:0',
    'END:VEVENT',
    'END:VCALENDAR'
  ].filter(Boolean);

  const text = lines.join('\r\n');

  return 'data:text/calendar;charset=utf8,' + encodeURI(text);
}

export function toSnakeCase(text: string): string {
  return (
    text
      .trim()
      .replace(/[\(\)\{\}\<\>\?\!\"\'\,\.\\/]/g, '')
      .replace(/[^a-z0-9_]/gi, '-')
  ).toLowerCase();
}

function getISODate(date: Date): string {
  const offset = date.getTimezoneOffset() / 60;
  return [
    date.getFullYear(),
    zeroPad(date.getMonth()),
    zeroPad(date.getDate()),
    'T',
    zeroPad(date.getHours() + offset),
    zeroPad(date.getMinutes()),
    zeroPad(date.getSeconds()),
    'Z'
  ].join('');
}

function zeroPad(num: number): string {
  return `${num}`.padStart(2, '0');
}

function objectToQueryParams(params: Record<string, string>): string {
  return Object.entries(params).reduce(
    (queryParams, [key, value]) => queryParams.concat(`${key}=${value}`),
    []
  ).join('&');
}
